import React from 'react';
import styles from './NoLinkedAccountPanel.module.css'; 
import { InnocodeButton } from '@intsoft/innocode-core';

function NoLinkedAccountPanel({ onSignup, onLinkAccount }) {
  return (
    <>
      <div className={styles.signup_section}>
        <div className={styles.success_content}>
          <div className={styles.icon_box}>
            <img
              src="/assets/help-icon.svg"
              alt="help-icon"
              className={styles.success_icon}
            />
          </div>
          <div className={`innocode-typography--title-lg innocode-typography--bold ${styles.title_text}`}>
            간편로그인 계정과 연동된
            <br />
            IAM 계정이 없습니다.
          </div>
          <div className={`innocode-typography--body-md-reading innocode-typography--regular ${styles.description_text}`}>
            간편 로그인 계정을 연결해 편리하게 로그인 하세요!
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton size="lg" onClick={onLinkAccount} designType={'assistive'} theme={'line'} className={styles.submit_btn}>IAM 기존 계정 연동</InnocodeButton>
        <InnocodeButton size="lg" onClick={onSignup} designType={'primary'} theme={'solid'} className={styles.submit_btn}>IAM 회원가입</InnocodeButton>
        {/* <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_assistive} ${components.btn_lg} ${styles.submit_btn}`}
          onClick={onLinkAccount}
        >
          <span className={components.btn__text}>IAM 기존 계정 연동</span>
        </button>
        <button
          type="button"
          className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.submit_btn}`}
          onClick={onSignup}
        >
          <span className={components.btn__text}>IAM 회원가입</span>
        </button> */}
      </div>
    </>
  );
}

export default NoLinkedAccountPanel;